import { SxProps, Theme } from '@mui/material'

export const containerSx: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.background.paper,
}

export const blogBreadcrumbTitleSx: SxProps<Theme> = {
  cursor: 'pointer',
  alignSelf: 'start',
  paddingBottom: '0.8rem',
  color: (theme) => theme.palette.primary.main,
  borderBottom: (theme) => `0.1rem solid ${theme.palette.primary.main}`,
}

export const contentSx: SxProps<Theme> = {
  flex: 1,
  maxWidth: {
    xl: '182.4rem',
  },
  padding: {
    xs: '0 2.4rem',
    md: '0 5.6rem',
    lg: '0 4.8rem',
    xl: 0,
  },
  margin: 'auto',
}

export const contentGridItemContainerSx: SxProps<Theme> = {
  marginBottom: '-6rem',
}

export const contentGridItemHeaderSx: SxProps<Theme> = {
  gap: '2.4rem',
}

export const loadingWrapperSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '50vh',
}

export const contentGridSx: SxProps<Theme> = {
  margin: { xs: '2.4rem 0', md: '2.4rem 0 4rem 0', lg: '6rem 0' },
  rowGap: { xs: '2.4rem', lg: '6rem' },
  maxWidth: {
    xl: '182.4rem',
  },
}

export const sidebarSx: SxProps<Theme> = {
  width: { xs: '100%', lg: '43.3rem' },
  marginLeft: 'auto',
}

export const sidebarWrapperSx: SxProps<Theme> = {
  gap: { xs: '2.4rem', md: '4rem', lg: '5.6rem' },
}

export const buttonsWrapperSx: SxProps<Theme> = {
  flexDirection: 'row',
  gap: '4rem',
}

export const imageSx: SxProps<Theme> = {
  width: '100%',
  marginTop: { xs: '2.4rem', md: '4.4rem' },
  objectFit: 'cover',
}

export const descriptionWrapperSx: SxProps<Theme> = {
  marginTop: '2.4rem',
}

export const blogPostAuthorAndDateSx: SxProps<Theme> = {
  marginTop: '1.6rem',
  display: 'flex',
  flexDirection: 'row',
  color: (theme) => theme.palette.text.secondary,
}

export const titleSx: SxProps<Theme> = {
  overflowWrap: 'break-word',
}
